import { render, staticRenderFns } from "./goodsGiftDetail.vue?vue&type=template&id=9fba9e3e&scoped=true&"
import script from "./goodsGiftDetail.vue?vue&type=script&lang=js&"
export * from "./goodsGiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsGiftDetail.vue?vue&type=style&index=0&id=9fba9e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fba9e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fba9e3e')) {
      api.createRecord('9fba9e3e', component.options)
    } else {
      api.reload('9fba9e3e', component.options)
    }
    module.hot.accept("./goodsGiftDetail.vue?vue&type=template&id=9fba9e3e&scoped=true&", function () {
      api.rerender('9fba9e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/saleDetail/goodsGiftDetail.vue"
export default component.exports